import { CmsEffects } from './cms.effect';
import { FeatureFlagEffects } from './feature-flag.effect';
import { MenuNestedEffects } from './menu-nested.effects';
import { SetCookieEffects } from './set-cookie.effect';

export const effects: any[] = [CmsEffects, FeatureFlagEffects, MenuNestedEffects, SetCookieEffects];
